import React, { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
const Faq = () => {
  const [currentActive, setCurrentActive] = useState(1);

  const faqdata = [
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit?",
      ans: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi suscipit in elementum nunc, a nulla nec dictumst. Vitae, sit eu commodo erat eget fusce faucibus. Nunc massa sit turpis montes. Mauris dolor dignissim sed sagittis fermentum et euismod duis libero.",
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit?",
      ans: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi suscipit in elementum nunc, a nulla nec dictumst. Vitae, sit eu commodo erat eget fusce faucibus. Nunc massa sit turpis montes. Mauris dolor dignissim sed sagittis fermentum et euismod duis libero.",
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit?",
      ans: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi suscipit in elementum nunc, a nulla nec dictumst. Vitae, sit eu commodo erat eget fusce faucibus. Nunc massa sit turpis montes. Mauris dolor dignissim sed sagittis fermentum et euismod duis libero.",
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit?",
      ans: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi suscipit in elementum nunc, a nulla nec dictumst. Vitae, sit eu commodo erat eget fusce faucibus. Nunc massa sit turpis montes. Mauris dolor dignissim sed sagittis fermentum et euismod duis libero.",
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit?",
      ans: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi suscipit in elementum nunc, a nulla nec dictumst. Vitae, sit eu commodo erat eget fusce faucibus. Nunc massa sit turpis montes. Mauris dolor dignissim sed sagittis fermentum et euismod duis libero.",
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit?",
      ans: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi suscipit in elementum nunc, a nulla nec dictumst. Vitae, sit eu commodo erat eget fusce faucibus. Nunc massa sit turpis montes. Mauris dolor dignissim sed sagittis fermentum et euismod duis libero.",
    },
  ];

  const clickHandler = (i) => {
    if (currentActive === i) {
      setCurrentActive(-1);
      return;
    }
    setCurrentActive(i);
  };

  return (
    <section className="py-40">
      <div className="container">
        <h1 className="text-[30px] md:text-[44px]  font-semibold text-center">
          More about{" "}
          <span className="text-primary font-semibold mb-4"> D3 Protocol </span>
        </h1>
        <div className="mt-10 max-w-4xl mx-auto">
          {faqdata.map((val, i) => (
            <div className=" py-4">
              <button
                className=" text-base md:text-xl capitalize flex items-center justify-between w-full"
                onClick={() => clickHandler(i)}
              >
                <span className=" text-left">{val.question}</span>
                <span>{currentActive === i ? <FaMinus /> : <FaPlus />}</span>
              </button>
              <div
                className={` overflow-hidden text-gray transition-all duration-500 ease-in-out  ${
                  currentActive === i ? " max-h-[200px] " : " max-h-[0px] "
                }`}
              >
                <p className="py-2">{val.ans}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
